/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:20:42
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title11 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';

class P12 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = '2px solid #000';
    return tableColumns.map(({ children, ...item }) => {
      return {
        ...item,
        ...(Array.isArray(children) && {children: this.fillColor(children)}),
        style: {
          ...item.style,
          fontSize: 14,
          fontWeight: 500,
          textAlign: 'center',
          background: '#fff',
          color: '#000',
          borderRight: border,
          borderBottom: border,
          whiteSpace: 'nowrap',
        },
        colStyle: {
          fontSize: 14,
          fontWeight: 500,
          textAlign: 'center',
          borderRight: border,
          borderBottom: border,
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    return (
      <Stage>
        <Title11 pageNumber="4.6">媒介渠道分类对比-<span className={s.titleHite}>按平台</span></Title11>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
            ①按照不同平台划分媒介渠道，贡献度排列前三的平台为微博、钛媒体和抖音；②围绕新品X85 Pro电视上市的推广侧重于前三渠道，因此在消费社区类平台上效果一般；③B站平台4月相关内容条数为215条，大于视频号平台，但获得的DB值缺远小于视频号平台，表明B站平台的传播效果和效率明显下降。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <Chart isShow options={setChart({ title: chartTitle, list: chartList, color: chartColorList })} />
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable
                  columns={this.fillColor(tableColumns)}
                  data={tableList}
                  style={{
                    borderTop: '2px solid #000',
                    borderLeft: '2px solid #000',
                  }}
                />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P12);



// WEBPACK FOOTER //
// src/routes/visualChart/P12/index.js